export default __webpack_public_path__ + "static/media/img-1.8329f006.jpg";